import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
import useAuth from "../../hooks/useAuth.js";
import reviewImg from "../../assets/userplace.png";
import comaImg from "../../assets/coma.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

const ReviewsCarousel = ({ reviews }) => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <>
      {"★".repeat(fullStars)}
      {halfStar && <span>☆</span>}
      {"☆".repeat(emptyStars)}
    </>
  );
};


  return (
    <div className="review-main">
      {reviews.length === 0 && Boolean(auth?.role) && (
        <div className="hint-msg">{t("hints.no_reviews")}</div>
      )}

   
      {reviews.length > 0 && (
        <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={20}
            slidesPerView={2}
            loop={true}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
            }}
          >
            {reviews.map((review, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="review-bg">
                    <div className="review-card">
                      <div className="review-header">
                        <img
                          src={reviewImg}
                          alt="Reviewer"
                          className="profile-img"
                        />
                        <div className="stars">{renderStars(review.rating || 0)}</div>
                      </div>
                      <div className="review-content">
                        <h3>{review.title}</h3>
                        <p className="review-txt">{review.comment}</p>
                        <div className="review-footer">
                          <p className="review-info">
                            <strong className="guest-name">
                              {review.guestName}
                            </strong>
                            <br />
                            <span className="review-date">{review.date}</span>
                          </p>
                        </div>
                      </div>

                      <img src={comaImg} className="quote-icon" alt="" />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default ReviewsCarousel;
